import { sizeTab, a11yProps, useCheckPermissions } from "@/shared";
import { CustomTabPanel, FormTabsOnly, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab } from "@mui/material";
import { useState } from "react";
import SolicitudOtpPendientePage from "./solicitud-otp-pendiente/SolicitudOtpPendientePage";
import SolicitudOtpVerificadoPage from "./solicitud-otp-verificado/SolicitudOtpVerificadoPage";
import SolicitudOtpExpiradoPage from "./solicitud-otp-expirados/SolicitudOtpExpiradoPage";
import { PermissionsEnum } from "@/auth/interfaces";

export default function SolicitudOtpPage() {

  useCheckPermissions(PermissionsEnum.api_view_codigootp);

  const [valueTab, setValueTab] = useState(0);
  const handleMethodChange = (_event: any, newValue: number) => {
    setValueTab(newValue);
  };

  return (
    <SingleTableBoxScene title="Solicitud de Aprobación de Código OTP">
      <Box
        sx={{
          bgcolor: 'background.paper',
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Pendientes" value={0} {...a11yProps(0)} />
          <Tab label="Verificados" value={1} {...a11yProps(1)} />
          <Tab label="Expirados" value={2} {...a11yProps(2)} />
        </FormTabsOnly>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <SolicitudOtpPendientePage />
      </CustomTabPanel>

      <CustomTabPanel value={valueTab} index={1}>
        <SolicitudOtpVerificadoPage />
      </CustomTabPanel>

      <CustomTabPanel value={valueTab} index={2}>
        <SolicitudOtpExpiradoPage />
      </CustomTabPanel>

    </SingleTableBoxScene>
  );

}